// extracted by mini-css-extract-plugin
module.exports = {"container":"_2kz276Cu0CiCwsLUUrMERG","visible":"_2i-2TB4HPjQe_DiLl31qMd","cancelBtn":"_2OVhaw1yhwRZnXQrtAJg3y","icon":"_6UkdjTDiUE4Vp38Dz_zhE","saveBtn":"dmJ9sdgeBdlvQskbazmSt"};